import _BaseController from 'Controllers/Web/_BaseController';
import ReadController from 'Vue/Web/Common/Note/ReadController.vue';
import Datalayer from 'Controllers/Web/Datalayer';

/* html 圖片放大縮小 */
// import 'magnific-popup';
// import 'magnific-popup/src/css/main.scss';

global.Controller = new (class extends _BaseController {
  ReadController?: Vue;

  ready() {
    super.ready();

    this.ReadController = new Vue(ReadController);
    // datalayer
    Datalayer.push(Json.datalayer);

    // this.ReadController = new Vue({
    //   el: '.content',
    //   components: {
    //     CourseComponent,
    //     ProductComponent,
    //     FavoriteComponent,
    //     MyMarkBlock,
    //   },
    //   methods: {
    //     scrollToId(id, event) {
    //       event.preventDefault();
    //       const targetElement = document.getElementById(id);
    //       if (targetElement) {
    //         const offset = 200; // 假設你的頭部導航條高度為 100px
    //         const bodyRect = document.body.getBoundingClientRect().top;
    //         const elementRect = targetElement.getBoundingClientRect().top;
    //         const elementPosition = elementRect - bodyRect;
    //         const offsetPosition = elementPosition - offset;
    //
    //         window.scrollTo({
    //           top: offsetPosition,
    //           behavior: 'smooth'
    //         });
    //       }
    //     }
    //   }
    // });

    // 初始化輪播
    $(window).on('load', () => {
      /* html 圖片放大縮小 */
      // $('.image').magnificPopup({
      //   delegate: 'img', // 代表初始化於圖片元素
      //   type: 'image',
      //   removalDelay: 100, // 延遲移除時間以允許動畫播放
      //   gallery: {
      //     enabled: false, // 啟用畫廊功能
      //   },
      //   callbacks: {
      //     elementParse: function(item) {
      //       let originalSrc = $(item.el[0]).attr('src');
      //       // 输出被解析项目的信息，看src是否正确
      //       item.src = originalSrc;
      //     }
      //   }
      // });
      $('.courseCarousel .owl-carousel').owlCarousel({
        autoplay: false, // 自動撥放
        loop: false, // 圖片循環
        center: false, // 是否置中
        navText: [], // 箭頭預設文字消失
        nav: false, // 前後箭頭
        dot: true,
        margin: 10,
        responsive: {
          0: {
            items: 1,
          },
          480: {
            items: 2,
          },
          768: {
            items: 3,
          },
          1024: {
            margin: 20,
          },
        },
      });

      $('.productCarousel .owl-carousel').owlCarousel({
        autoplay: false, // 自動撥放
        loop: false, // 圖片循環
        center: false, // 是否置中
        navText: [], // 箭頭預設文字消失
        nav: false, // 前後箭頭
        dot: true,
        responsive: {
          0: {
            items: 1,
          },
          480: {
            items: 2,
          },
          768: {
            items: 3,
          },
        },
      });
    });


  }
})();
